module.exports = __webpack_public_path__ + "img/vertical_6_6_3009.7dca26b6.png";